import { QueryFilter } from "src/app/shared/models/query-filter.model";

export class OutingIterationDetailsQueryFilter extends QueryFilter{
    public outingIterationId: string;
}